import { useStoreDollHouseMap } from "../../store";

import { useEffect, useState } from "react";
import AriaBuildingHotspot from "./AriaLevel_Hotspots";
import CosmopolitanLevel_Hotspots from "./CosmopolitanLevel_Hotspots";
import BellagioHotspot from "./BellagioHotspot";
import VdaraHotspots from "./VdaraHotspots";
import ParkMgmHotspots from "./ParkMgmHotspots";
import NomadHotspots from "./NomadHotspots";
import DistrictHighlightHotspots from "./DistrictHighlightHotspots";
import { shallow } from "zustand/shallow";

export default function DollhouseHotspotsComponent() {
  const [selectedAria, setSelectedAria] = useState("");
  const [hoverContent, setHoverContent] = useState(null);
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      currentSidebarMenuSelected: state.currentSidebarMenuSelected,
    }),
    shallow
  );

  useEffect(() => {
    let selction = dollhouseStore.currentSidebarMenuSelected;

    // console.log("selction", selction);
    setSelectedAria(selction);
  }, [dollhouseStore.currentSidebarMenuSelected]);

  return (
    <>
      <DistrictHighlightHotspots hoverContent={hoverContent} />

      <CosmopolitanLevel_Hotspots
        hoverContent={hoverContent}
        selectedAria={selectedAria}
      />

      <BellagioHotspot hoverContent={hoverContent} />
      <VdaraHotspots hoverContent={hoverContent} />
      <ParkMgmHotspots hoverContent={hoverContent} />
      <NomadHotspots hoverContent={hoverContent} />
      <AriaBuildingHotspot
        hoverContent={hoverContent}
        selectedAria={selectedAria}
      />
    </>
  );
}
